import React from "react";
import SoarCard from "./SoarCard";
import FieldDisplay from "../common/FieldDisplay";
import {
  getFieldName,
  getFieldDate,
  getFieldTime,
} from "../../scripts/helperScripts";

const IncidentCard = ({ incident }) => {
  const reportOrg =
    process.env.REACT_APP_ENVIRONMENT === "Production"
      ? "SOARLive"
      : "SOARD365Base";
  return (
    <SoarCard
      title={incident.ccx_name}
      path={`/main.aspx?etc=10124&extraqs=formid%3d8ab00a9d-590f-4d3c-8a91-7487ed578a21&id=${incident.ccx_incidentreportid}&pagetype=entityrecord`}
      reportlink={
        getFieldName(incident["con.ownerid"]).includes("Nevada")
          ? `https://safyreports.azurewebsites.net/Reports/Incident/NVSpecial?db=${reportOrg}&i=${incident.ccx_incidentreportid}`
          : `https://safyreports.azurewebsites.net/Reports/Incident/Client?db=${reportOrg}&i=${incident.ccx_incidentreportid}`
      }
      body={
        <>
          <FieldDisplay
            label="Client Program:"
            value={getFieldName(incident.sor_clientprogram)}
          />
          <FieldDisplay
            label="Date of Incident"
            value={getFieldDate(incident.ccx_dateandtimeofincident)}
          />
          <FieldDisplay
            label="Time of Incident"
            value={getFieldTime(incident.ccx_dateandtimeofincident)}
          />
          <FieldDisplay
            label="Incidend Type:"
            value={getFieldName(incident.sor_soarincidenttype)}
          />
          <FieldDisplay
            label="Where Did Incident Happen:"
            value={getFieldName(incident.sor_wheredidtheincidenthappen)}
          />
          <FieldDisplay
            label="Created By:"
            value={getFieldName(incident.createdby)}
          />

          <FieldDisplay
            label="Created On:"
            value={getFieldDate(incident.createdon)}
          />
          <FieldDisplay
            label="Signed By User:"
            value={getFieldName(incident.ccx_esignuser)}
          />
        </>
      }
    />
  );
};

export default IncidentCard;
